webpackJsonp([1],{

/***/ "0Kyw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__("7q3b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35e099ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__("R48G");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35e099ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4O6E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('div',{staticClass:"mui-panel",attrs:{"id":"topnav"}},[_c('img',{attrs:{"id":"logo","src":__webpack_require__("7Otq"),"alt":"logo"}}),_vm._v(" "),_c('div',{staticClass:"mui--pull-right"},[_c('router-link',{attrs:{"to":"logout"}},[_vm._v("Logout")])],1),_vm._v(" "),(_vm.admin)?_c('div',{staticClass:"mui--pull-right"},[_c('router-link',{attrs:{"to":"admin"}},[_vm._v("Admin")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mui--pull-right"},[_c('router-link',{attrs:{"to":"sku"}},[_vm._v("SKU")])],1),_vm._v(" "),_c('div',{staticClass:"mui--pull-right"},[_c('router-link',{attrs:{"to":"catalog"}},[_vm._v("Catalog")])],1)]),_vm._v(" "),_c('div',{staticClass:"mui-panel",attrs:{"id":"content"}},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.8b9c48b.png";

/***/ }),

/***/ "7q3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'logout',
    mounted: function mounted() {
        localStorage.removeItem('token');
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOGOUT_USER');
        __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/');
    }
});

/***/ }),

/***/ "F388":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mui-container",attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GdQo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "sku",
  data: function data() {
    return {
      filter: "",
      products: [],
      connmsg: ""
    };
  },
  beforeCreate: function beforeCreate() {
    if (!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.isLogged) {
      __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push("/");
    }
  },
  created: function created() {
    this.getProducts();
  },

  methods: {
    getProducts: function getProducts() {
      var _this = this;

      this.axios.get("getsku").then(function (response) {
        _this.products = response.data;
      }, function () {
        _this.connmsg = "Error: Could not reach server!";
      });
    }
  },
  computed: {
    filteredItems: function filteredItems() {
      var self = this;
      return self.products.filter(function (product) {
        return product.sku.toLowerCase().indexOf(self.filter.toLowerCase()) > -1;
      });
    }
  }
});

/***/ }),

/***/ "Gr/e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sku"},[_c('h2',[_vm._v("SKU-Search")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.connmsg))]),_c('br'),_vm._v(" "),_c('div',{staticClass:"mui-textfield"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],attrs:{"type":"text","placeholder":"Filter by SKU"},domProps:{"value":(_vm.filter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})]),_vm._v(" "),_c('table',{staticClass:"mui-table mui-table--bordered"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredItems),function(product){return _c('tr',{key:product.sku},[_c('td',[_vm._v(_vm._s(product.sku))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.qty))])])}))])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("SKU")]),_vm._v(" "),_c('th',[_vm._v("Qty")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HZnY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
    isLogged: !!localStorage.getItem('token'),
    admin: false
};

var mutations = {
    LOGIN_USER: function LOGIN_USER(state) {
        state.isLogged = true;
        if (localStorage.getItem('token') === 'admin') {
            state.admin = true;
        }
    },
    LOGOUT_USER: function LOGOUT_USER(state) {
        state.isLogged = false;
        state.admin = false;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    strict: "production" !== 'production',
    state: state,
    mutations: mutations
}));

/***/ }),

/***/ "Jaup":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KS52":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'admin',
    data: function data() {
        return {
            user: '',
            password: '',
            role: 'viewer',
            syncmsg: '',
            connmsg: '',
            createmsg: '',
            deletemsg: '',
            users: ''
        };
    },
    beforeCreate: function beforeCreate() {
        if (!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.isLogged || !__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.admin) {
            __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/');
        }
    },
    created: function created() {
        this.getUsers();
    },

    methods: {
        syncData: function syncData() {
            var _this = this;

            this.axios.get('sync').then(function (response) {
                _this.syncmsg = response.data.status;
            }, function () {
                _this.syncmsg = 'Error: Could not reach server!';
            });
        },
        getUsers: function getUsers() {
            var _this2 = this;

            this.axios.get('getuser').then(function (response) {
                _this2.users = response.data;
            }, function () {
                _this2.connmsg = 'Error: Could not reach server!';
            });
        },
        createUser: function createUser() {
            var _this3 = this;

            this.axios.post('insertuser', {
                user: this.user,
                password: this.password,
                role: this.role
            }).then(function (response) {
                _this3.createmsg = response.data.status;
                _this3.getUsers();
            }, function () {
                _this3.connmsg = 'Error: Could not reach server!';
            });
        },
        deleteUser: function deleteUser(id) {
            var _this4 = this;

            this.axios.delete('deleteuser', { params: { id: id } }).then(function (response) {
                _this4.deletemsg = response.data.status;
                _this4.getUsers();
            }, function () {
                _this4.connmsg = 'Error: Could not reach server!';
            });
        }
    }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2423bf6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("F388");
function injectStyle (ssrContext) {
  __webpack_require__("Jaup")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2423bf6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = 'https://stock.a4life.de/api/';
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

/***/ }),

/***/ "Ppzn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin"},[_c('h2',[_vm._v("Admin")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.syncmsg))]),_c('br'),_vm._v(" "),_c('button',{staticClass:"mui-btn mui-btn--raised",on:{"click":function($event){_vm.syncData()}}},[_vm._v("Sync Data")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.connmsg))]),_c('br'),_vm._v(" "),_c('table',{staticClass:"mui-table mui-table--bordered"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.users),function(user){return _c('tbody',{key:user.id},[_c('tr',[_c('td',[_vm._v(_vm._s(user.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.user))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.role))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"mui-btn mui-btn--raised",on:{"click":function($event){_vm.deleteUser(user.id)}}},[_vm._v("Delete")])])])])})],2),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.deletemsg))]),_c('br'),_vm._v(" "),_c('form',{staticClass:"mui-form",on:{"submit":function($event){$event.preventDefault();_vm.createUser($event)}}},[_c('legend',[_vm._v("Create User")]),_vm._v(" "),_c('div',{staticClass:"mui-textfield"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.user),expression:"user",modifiers:{"trim":true}}],attrs:{"name":"user","type":"text","placeholder":"Name"},domProps:{"value":(_vm.user)},on:{"input":function($event){if($event.target.composing){ return; }_vm.user=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"mui-textfield"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.password),expression:"password",modifiers:{"trim":true}}],attrs:{"name":"password","type":"password","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"mui-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.role),expression:"role"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.role=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("viewer")]),_vm._v(" "),_c('option',[_vm._v("admin")])]),_vm._v(" "),_c('label',[_vm._v("Role")])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.createmsg))]),_c('br'),_vm._v(" "),_c('button',{staticClass:"mui-btn mui-btn--raised",attrs:{"type":"submit"}},[_vm._v("Submit")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("User")]),_vm._v(" "),_c('th',[_vm._v("Role")]),_vm._v(" "),_c('th',[_vm._v("Action")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R48G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T4We":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"catalog"},[_c('h2',[_vm._v("Catalog")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.connmsg))]),_c('br'),_vm._v(" "),_c('div',{staticClass:"mui-container-fluid"},[_c('div',{staticClass:"mui-row"},[_c('div',{staticClass:"mui-select mui-col-md-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSystem),expression:"filterSystem"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterSystem=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("All")]),_vm._v(" "),_c('option',[_vm._v("Astra Tech Osseospeed EV 4.2")]),_vm._v(" "),_c('option',[_vm._v("Astra Tech Osseospeed 3.5/4.0")]),_vm._v(" "),_c('option',[_vm._v("Astra Tech Osseospeed 4.5/5.0")]),_vm._v(" "),_c('option',[_vm._v("Conelog 3.8")]),_vm._v(" "),_c('option',[_vm._v("Megagen Anyridge 3.5/8.4")]),_vm._v(" "),_c('option',[_vm._v("Nobel Biocare Active NP 3.5")]),_vm._v(" "),_c('option',[_vm._v("Osstem TS Mini 3.5")]),_vm._v(" "),_c('option',[_vm._v("Straumann NC 3.3")]),_vm._v(" "),_c('option',[_vm._v("Straumann RC 4.1/4.8")]),_vm._v(" "),_c('option',[_vm._v("Zimmer TPS/MiS Seven/BHI/Alpha-Bio 3.5")]),_vm._v(" "),_c('option',[_vm._v("Screw")]),_vm._v(" "),_c('option',[_vm._v("Tool")]),_vm._v(" "),_c('option',[_vm._v("Zirconia Preparation Set")])]),_vm._v(" "),_c('label',[_vm._v("System")])]),_vm._v(" "),_c('div',{staticClass:"mui-select mui-col-md-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterType),expression:"filterType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("All")]),_vm._v(" "),_vm._l((_vm.listyy),function(yy){return _c('option',{key:yy},[_vm._v(_vm._s(yy))])})],2),_vm._v(" "),_c('label',[_vm._v("Type")])]),_vm._v(" "),_c('div',{staticClass:"mui-select mui-col-md-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSpec),expression:"filterSpec"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterSpec=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("All")]),_vm._v(" "),_vm._l((_vm.listzz),function(zz){return _c('option',{key:zz},[_vm._v(_vm._s(zz))])})],2),_vm._v(" "),_c('label',[_vm._v("Spec")])])])]),_vm._v(" "),_c('table',{staticClass:"mui-table mui-table--bordered"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredItems),function(product){return _c('tr',{key:product.sku_a4l},[_c('td',[_vm._v(_vm._s(product.sku_a4l))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.sku_cm))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.xx))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.yy))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.zz))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.ab))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.qty))])])}))])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("SKU A4L")]),_vm._v(" "),_c('th',[_vm._v("SKU C+M")]),_vm._v(" "),_c('th',[_vm._v("System")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Spec")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("QTY")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TGvd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("aEfQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaecee40_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("4O6E");
function injectStyle (ssrContext) {
  __webpack_require__("HZnY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aaecee40"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaecee40_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Logout__ = __webpack_require__("0Kyw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard__ = __webpack_require__("TGvd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Admin__ = __webpack_require__("qbhH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Sku__ = __webpack_require__("wIPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Catalog__ = __webpack_require__("w62z");









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: '/',
  routes: [{
    path: '/',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Login__["a" /* default */]
  }, {
    path: '/logout',
    name: 'logout',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Logout__["a" /* default */]
  }, {
    path: '/dashboard',
    name: 'dashboard',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Dashboard__["a" /* default */],
    children: [{
      path: '/admin',
      name: 'admin',
      component: __WEBPACK_IMPORTED_MODULE_5__components_Admin__["a" /* default */]
    }, {
      path: '/sku',
      name: 'sku',
      component: __WEBPACK_IMPORTED_MODULE_6__components_Sku__["a" /* default */]
    }, {
      path: '/catalog',
      name: 'catalog',
      component: __WEBPACK_IMPORTED_MODULE_7__components_Catalog__["a" /* default */]
    }]
  }]
}));

/***/ }),

/***/ "YyZ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'catalog',
  data: function data() {
    return {
      filterSystem: 'All',
      filterType: 'All',
      filterSpec: 'All',
      products: [],
      listyy: ['C-Base', 'Diameter 1.6 mm', 'Diameter 1.8 mm', 'Diameter 2.0 mm', 'Gingiva Former Pekkton', 'LTS-Base', 'LTS-Hybrid Abutment Zirconium', 'Preform Titanium', 'Scanbody', 'Screw Driver', 'T-Base', 'N/A'],
      listzz: ['Angulated', 'Anterior Small', 'Anterior Large', 'ISO-Shaft', 'Length 6.1 mm', 'Length 7.1 mm', 'Length 7.9 mm', 'Length 8.0 mm', 'Length 8.6 mm', 'Length 8.3 mm', 'Length 6.7 mm', 'Length 6.8 mm', 'Length 7.8 mm', 'Manual', 'Molar', 'Molar Inverse', 'Premolar', 'Premolar Straight', 'Small Platform', 'Straight', 'Wide Platform', 'N/A'],
      connmsg: '',
      sortAsc: true
    };
  },
  beforeCreate: function beforeCreate() {
    if (!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.isLogged) {
      __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/');
    }
  },
  created: function created() {
    this.getProducts();
  },

  methods: {
    getProducts: function getProducts() {
      var _this = this;

      this.axios.get('getcatalog').then(function (response) {
        _this.products = response.data;
      }, function () {
        _this.connmsg = 'Error: Could not reach server!';
      });
    }
  },
  computed: {
    filteredItems: function filteredItems() {
      var self = this;
      var result = self.products;
      if (self.filterSystem != 'All') {
        result = result.filter(function (product) {
          return product.xx.includes(self.filterSystem);
        });
      }
      if (self.filterType != 'All') {
        result = result.filter(function (product) {
          return product.yy.includes(self.filterType);
        });
      }
      if (self.filterSpec != 'All') {
        if (self.filterSpec === 'Molar' || self.filterSpec === 'Premolar' || self.filterSpec === 'Straight') {
          result = result.filter(function (product) {
            if (product.zz.includes(self.filterSpec) && product.zz.length < 9) {
              return true;
            } else {
              return false;
            }
          });
        } else {
          result = result.filter(function (product) {
            return product.zz.includes(self.filterSpec);
          });
        }
      }
      // Sort the remaining values
      var ascDesc = this.sortAsc ? 1 : -1;
      return result.sort(function (a, b) {
        return ascDesc * a.sku_a4l.localeCompare(b.sku_a4l);
      });
    },
    filteredYY: function filteredYY() {
      var self = this;
      var result = self.listyy;
    }
  }
});

/***/ }),

/***/ "aEfQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dashboard',
    data: function data() {
        return {
            admin: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.admin
        };
    },
    beforeCreate: function beforeCreate() {
        if (!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.isLogged) {
            __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/');
        } else {
            __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/catalog');
        }
    }
});

/***/ }),

/***/ "j4sa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m34L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mw0l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      loader: false,
      infoError: false,
      user: '',
      password: '',
      msg: ''
    };
  },
  beforeCreate: function beforeCreate() {
    if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.isLogged) {
      __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/dashboard');
    }
  },

  methods: {
    login: function login() {
      var _this = this;

      this.loader = true;
      this.infoError = false;
      this.axios.post('validatelogin', {
        user: this.user,
        password: this.password
      }).then(function (response) {
        if (response.data.status == 'ok') {
          localStorage.setItem('token', response.data.role);
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOGIN_USER');
          __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/dashboard');
        } else {
          _this.loader = false;
          _this.password = '';
          _this.msg = response.data.status;
        }
      }, function () {
        _this.infoError = true;
        _this.loader = false;
        _this.password = '';
      });
    }
  }
});

/***/ }),

/***/ "qbhH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admin_vue__ = __webpack_require__("KS52");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d4a73ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Admin_vue__ = __webpack_require__("Ppzn");
function injectStyle (ssrContext) {
  __webpack_require__("mw0l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9d4a73ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d4a73ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Admin_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w62z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Catalog_vue__ = __webpack_require__("YyZ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34a0de36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Catalog_vue__ = __webpack_require__("T4We");
function injectStyle (ssrContext) {
  __webpack_require__("j4sa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34a0de36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Catalog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34a0de36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Catalog_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wIPx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sku_vue__ = __webpack_require__("GdQo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8bd742e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Sku_vue__ = __webpack_require__("Gr/e");
function injectStyle (ssrContext) {
  __webpack_require__("m34L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c8bd742e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sku_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8bd742e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Sku_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49931535_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("zLj2");
function injectStyle (ssrContext) {
  __webpack_require__("zydl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49931535"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49931535_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zLj2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"mui-form",attrs:{"id":"login-form"},on:{"submit":function($event){$event.preventDefault();_vm.login($event)}}},[_c('img',{attrs:{"src":__webpack_require__("7Otq")}}),_vm._v(" "),_c('legend',[_vm._v("Login")]),_vm._v(" "),(_vm.infoError)?_c('div',{staticClass:"info info--error"},[_vm._v("Login failed. Please try again.")]):_vm._e(),_vm._v(" "),_c('div',{class:{'is-waiting': _vm.loader}},[_c('div',{staticClass:"mui-textfield"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.user),expression:"user",modifiers:{"trim":true}}],attrs:{"name":"user","type":"text","placeholder":"User","required":""},domProps:{"value":(_vm.user)},on:{"input":function($event){if($event.target.composing){ return; }_vm.user=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"mui-textfield"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.password),expression:"password",modifiers:{"trim":true}}],attrs:{"name":"password","type":"password","placeholder":"Password","required":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.msg))]),_c('br'),_vm._v(" "),_c('button',{staticClass:"mui-btn mui-btn--raised"},[_vm._v("Login")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zydl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.0b97fea887cc212b0a56.js